export class MenuMobile {

    constructor(){
        this.$menu = $('.c-menu-mobile');
        this.$body = $('body');

        $('.js-open-menu-mobile').on('click', () => this.open());
        $('.c-menu-mobile__item--has-children').on('click', e => this.openSubMenu(e));
        $('.js-close-menu-mobile').on('click', () => this.close());
        this.$body.on('click', '.ui-overlay', () => this.close());
    }

    open() {
        this.$menu.addClass('c-menu-mobile--open');
        this.$body.addClass('body--no-scroll');
        this.$body.append('<div class="ui-overlay"></div>');
    }

    close() {
        this.$menu.removeClass('c-menu-mobile--open');
        this.$body.removeClass('body--no-scroll');
        $('.ui-overlay').remove();
    }

    openSubMenu(e) {
        $(e.currentTarget).find('.c-menu-mobile__sub-menu').slideToggle();
    }

}
